// extracted by mini-css-extract-plugin
export default {"link":"styles_link__yD9ky","menuitem":"styles_menuitem__Ohvr6","active":"styles_active__-P+BG"};